import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { env } from "../../../../../env";
import axiosInstance from "../../../../globalInspector/axiosInstance";
import CommonToast from "../../../../../components/_utils/CommonToast";
import ICONS from "../../../../../assets/Icons";

const baseUrl = env.REACT_APP_BASE_URL;

export const getFeatures = createAsyncThunk(
  "getFeatures",
  async ({ page_no, page_size, search_string }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/user_features`, {
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": sessionStorage.getItem("q2p_token"),
        },
        params: {
          page_no: page_no,
          page_size: page_size,
          search_string,
        },
      });
      return response.data;
    } catch (error) {
      CommonToast({
        text: error.response.data.error,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(error);
    }
  },
);

export const getSpecificFeature = createAsyncThunk(
  "getSpecificFeature",
  async (payload, { rejectWithValue }) => {
    const { id } = payload;
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/user_features/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

const featuresSlice = createSlice({
  name: "features",
  initialState: {
    allFeaturesData: [],
    allFeaturesIsLoading: true,
    allFeaturesFailData: null,

    getSpecificFeatureData: null,
    getSpecificFeatureIsLoading: true,
    getSpecificFeatureError: null,
  },
  extraReducers: (builder) => {
    builder.addCase(getFeatures.fulfilled, (state, action) => {
      state.allFeaturesData = action.payload;
      state.allFeaturesIsLoading = false;
    });
    builder.addCase(getFeatures.rejected, (state, action) => {
      state.allFeaturesData = null;
      state.allFeaturesIsLoading = false;
      state.allFeaturesFailData = action.payload;
    });
    builder.addCase(getFeatures.pending, (state, action) => {
      state.allFeaturesIsLoading = true;
    });
    builder.addCase(getSpecificFeature.fulfilled, (state, action) => {
      state.getSpecificFeatureData = action.payload;
      state.getSpecificFeatureIsLoading = false;
    });
    builder.addCase(getSpecificFeature.rejected, (state, action) => {
      state.getSpecificFeatureData = null;
      state.getSpecificFeatureIsLoading = false;
      state.getSpecificFeatureError = action.payload;
    });
    builder.addCase(getSpecificFeature.pending, (state, action) => {
      state.getSpecificFeatureIsLoading = true;
    });
  },
});

export default featuresSlice.reducer;
